module.exports = __webpack_public_path__ + "img/info-black.aacf2cbd.svg";